<div class="left-card pb-5">
  <div
    class="center-right-about"
    *ngIf="currentTab === 1"
    (click)="goToCenter()"
  >
    <i class="fas fa-chevron-right"></i>
  </div>
  <div class="width-card">
    <div class="row pt-5">
      <div class="col-12 col-md-3">
        <div class="top-image mb-3 mb-md-0">
          <img [src]="profileImage" *ngIf="profileImage" />
          <img
            src="assets\img\imagge.jpg"
            *ngIf="!profileImage"
            class="img-fluid"
          />
        </div>
      </div>
      <div class="col-12 col-md-9">
        <h1 class="break-word">{{ publicCardData.titulo }}</h1>
        <p class="break-word">{{ publicCardData.descripcion }}</p>
        <!-- <button mat-stroked-button class="mt-3" (click)="openContact()">
          {{ "contact_me" | translate }}
        </button> -->
        <!-- <a
          href="{{
            'https://api.whatsapp.com/send?phone=' +
              publicCardData.claveTelefono +
              this.publicCardData.telefono +
              '&text=Hola, Nececito mas informacion!'
          }}"
          *ngIf="this.publicCardData.telefono !== ''"
          style="font-size: 24px"
          >{{ "contact_me" | translate }}
          <i class="fab fa-whatsapp ml-2" style="font-size: 20px"></i>
        </a> -->
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 mb-3">
        <h1>{{ "contact" | translate }}</h1>
        <hr />
      </div>
      <div class="col-12 col-md-4">
        <a (click)="openContact()">
          <div class="contact">
            <div class="contact-element">
              <i class="fas fa-envelope contact-element__Icon"></i>
            </div>
            <div class="contact__description">
              <h2>{{ "email_address" | translate }}</h2>
              <p class="break-word">
                {{ publicCardData.correo }}
              </p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-4">
        <a [href]="getbuildShared('phone')" target="_blank">
          <div class="contact">
            <div class="contact-element">
              <i class="fas fa-mobile-alt contact-element__Icon"></i>
            </div>
            <div class="contact__description">
              <h2>{{ "phone" | translate }}</h2>
              <p>
                +({{ publicCardData.claveTelefono }})
                {{ publicCardData.telefono }}
              </p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md-4">
        <a [href]="getbuildShared('maps')" target="_blank">
          <div class="contact">
            <div class="contact-element">
              <i class="fas fa-map-marker-alt contact-element__Icon"></i>
            </div>
            <div class="contact__description">
              <h2>{{ "address" | translate }}</h2>
              <p>{{ publicCardData.domicilio }}</p>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 mb-3">
        <h1>{{ "social_networks" | translate }}</h1>
        <hr />
      </div>

      <div
        class="col-12 col-md-4 mt-2 mb-2"
        *ngFor="let network of socialNetworksList"
      >
        <a [href]="network.urlRedSocial" target="_blank">
          <div class="social-media">
            <i
              class="fab fa-facebook-square"
              *ngIf="network.redSocial === 'Facebook'"
            ></i>
            <i
              class="fab fa-instagram-square"
              *ngIf="network.redSocial === 'Instagram'"
            ></i>
            <i
              class="fab fa-twitter-square"
              *ngIf="network.redSocial === 'Twitter'"
            ></i>
            <i
              class="fab fa-linkedin"
              *ngIf="network.redSocial === 'LinkedIn'"
            ></i>
            <h2>{{ network.redSocial }}</h2>
          </div>
        </a>
      </div>
      <hr class="mt-3" />
    </div>

    <div class="row mt-5">
      <div class="col-12 text-center">
        <h1 class="mb-3">{{ "scan_my_card" | translate }}</h1>
        <ngx-qrcode [value]="urlQR" id="qr" (click)="addEventQr()">
        </ngx-qrcode>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 text-center">
        <h1>{{ "share" | translate }}</h1>
      </div>
      <div class="col-12">
        <div class="shared">
          <a [href]="getbuildShared('facebook')" target="_blank">
            <div
              class="cl-facebook"
              [tooltip]="'share_by_facebook' | translate"
              placement="top"
            >
              <i class="fab fa-facebook-f"></i>
            </div>
          </a>
          <a [href]="getbuildShared('whatssapp')" target="_blank">
            <div
              class="cl-whatssapp"
              [tooltip]="'share_by_whatsapp' | translate"
              placement="top"
            >
              <i class="fab fa-whatsapp"></i>
            </div>
          </a>
          <a [href]="getbuildShared('twitter')" target="_blank">
            <div
              class="cl-twitter"
              [tooltip]="'share_by_twitter' | translate"
              placement="top"
            >
              
            <!-- <i class="fab fa-twitter"></i> -->
            <i>
              <img src="assets/images/sociales/xcom_cuadrado.png" 
                width="30" height="30"
              />
            </i>
                      
          </div>          
          </a>
          <!-- <div
              ngxClipboard
              [cbContent]="urlQR"
              (click)="showSuccess()"
              class="cl-tiktok"
              [tooltip]="'share_by_tiktok' | translate"
              placement="top"
            >
              <i class="fab fa-tiktok"></i>
            </div> -->
          <!-- <div
              ngxClipboard
              [cbContent]="urlQR"
              (click)="showSuccess()"
              class="cl-instagram"
              [tooltip]="'share_by_instagram' | translate"
              placement="top"
            >
              <i class="fab fa-instagram"></i>
            </div> -->
          <a [href]="getbuildShared('sms')" target="_blank">
            <div
              class="cl-sms"
              [tooltip]="'share_by_sms' | translate"
              placement="top"
            >
              <i class="far fa-comments"></i>
            </div>
          </a>
          <div
            (click)="buildVCard()"
            class="cl-movil"
            [tooltip]="'save_contact' | translate"
            placement="top"
          >
            <i class="fas fa-mobile-alt"></i>
          </div>
          <div
            ngxClipboard
            [cbContent]="urlQR"
            (click)="showSuccess()"
            class="cl-copy"
            [tooltip]="'copy_site' | translate"
            placement="top"
          >
            <i class="far fa-copy"></i>
          </div>
        </div>
      </div>
      <div
        class="col-12 text-center"
        *ngIf="
          userId === publicCardData.idUsuario && publicCardData.crearTarjeta
        "
      >
        <div class="shared">
          <div
            class="cl-login"
            placement="top"
            [routerLink]="sessionActive ? ['/dashboard'] : ['/login']"
          >
            <i
              class="fas"
              [ngClass]="{
                'fa-sign-in-alt': !sessionActive,
                'fa-magic': sessionActive
              }"
            ></i>
          </div>
        </div>
        <div
          style="
            width: 0;
            height: 0;
            border-right: 10px solid transparent;
            border-top: 10px solid transparent;
            border-left: 10px solid transparent;
            border-bottom: 15px solid #000000;
            margin: auto;
          "
        ></div>
        <small
          style="
            padding: 20px;
            background: black;
            padding-top: 5px;
            padding-bottom: 5px;
            border-radius: 5px;
            color: white;
          "
          >{{ (sessionActive ? "edit" : "login") | translate }}
        </small>
      </div>

      <!-- <div
          class="col-12 text-center"
          *ngIf="userId !== publicCardData.idUsuario"
        >
          <div class="shared">
            <div
              class="cl-login"
              placement="top"
              [routerLink]="sessionActive ? ['/dashboard'] : ['/login']"
            >
              <i
                class="fas"
                [ngClass]="{
                  'fa-sign-in-alt': !sessionActive,
                  'fa-magic': sessionActive
                }"
              ></i>
            </div>
          </div>
          <div
            style="
              width: 0;
              height: 0;
              border-right: 10px solid transparent;
              border-top: 10px solid transparent;
              border-left: 10px solid transparent;
              border-bottom: 15px solid #000000;
              margin: auto;
            "
          ></div>
          <small
            style="
              padding: 20px;
              background: black;
              padding-top: 5px;
              padding-bottom: 5px;
              border-radius: 5px;
              color: white;
            "
            >{{ (sessionActive ? "edit" : "login") | translate }}
          </small>
        </div> -->

      <div
        class="col-12 text-center"
        *ngIf="!sessionActive && publicCardData.crearTarjeta"
      >
        <div class="shared">
          <div class="cl-login" placement="top" [routerLink]="['/login']">
            <i
              class="fas"
              [ngClass]="{
                'fa-sign-in-alt': !sessionActive,
                'fa-magic': sessionActive
              }"
            ></i>
          </div>
        </div>
        <div
          style="
            width: 0;
            height: 0;
            border-right: 10px solid transparent;
            border-top: 10px solid transparent;
            border-left: 10px solid transparent;
            border-bottom: 15px solid #000000;
            margin: auto;
          "
        ></div>
        <small
          style="
            padding: 20px;
            background: black;
            padding-top: 5px;
            padding-bottom: 5px;
            border-radius: 5px;
            color: white;
          "
          >{{ "login" | translate }}
        </small>
      </div>
    </div>
  </div>
</div>
